<form [formGroup]="form" (submit)="submit()" a11yFocusTrap a11yAutoFocus>
    <vwui-modal-header>
        <h2 a11yPageTitleLevel="2">{{ title | translate }}</h2>
    </vwui-modal-header>
    <vwui-modal-body>
        <vwui-form-group label="{{ 'PAGE_PROJECT_TYPES.table.column.name' | translate }}" inputId="name">
            <vwui-input inputId="name"
                        formControlName="name"
                        placeholder="{{ 'PAGE_PROJECT_TYPES.placeholder.name' | translate }}">
            </vwui-input>
        </vwui-form-group>
        <vwui-form-group label="{{ 'PAGE_PROJECT_TYPES.table.column.description' | translate }}" inputId="description">
            <vwui-textarea inputId="description"
                           formControlName="description"
                           placeholder="{{ 'PAGE_PROJECT_TYPES.placeholder.description' | translate }}">
            </vwui-textarea>
        </vwui-form-group>
    </vwui-modal-body>
    <vwui-modal-footer>
        <vwui-button class="is-light" (click)="modalRef.close()">
            {{ 'BUTTON.cancel' | translate }}
        </vwui-button>
        <vwui-button class="is-primary" (click)="submit()">
            {{ saveText | translate }}
        </vwui-button>
    </vwui-modal-footer>
</form>
